import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H6, P } from "../../../../../AbstractElements";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import { CopyFormText, CopyFromParagraph, CopyHighlightedText, CopyPortionParagraphTitle } from "../../../../../Utils/Constants";

export default function CopyPortionFromParagraph() {
  const copyPortionParagraphText: string = "that are visible online. Take a website design course to learn how to  create an appealing and responsive website. In the discipline of web design, there are degree, diploma, postgraduate degree, and certificate programmes. A web designer is responsible for a website's look, feel, and occasionally even content.";
  const [highlightTextValue, setHighlightTextValue] = useState(copyPortionParagraphText);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(highlightTextValue);
    setHighlightTextValue(highlightTextValue);
  };
  return (
    <Col sm={12} md={6}>
      <Card className="height-equal">
        <CommonCardHeader headClass="pb-0" title={CopyPortionParagraphTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="f-16">{CopyFromParagraph}</P>
            <H6 className="border rounded card-body f-w-300">
              <span className="bg-primary text-white p-1">{CopyFormText}</span>
              {copyPortionParagraphText}
            </H6>
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard" color="secondary" onClick={handleCopy}>
                <i className="fa fa-copy"></i> {CopyHighlightedText}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
